import { render, staticRenderFns } from "./LeftHandedIcon.vue?vue&type=template&id=f070454a&scoped=true"
import script from "./LeftHandedIcon.vue?vue&type=script&lang=js"
export * from "./LeftHandedIcon.vue?vue&type=script&lang=js"
import style0 from "./LeftHandedIcon.vue?vue&type=style&index=0&id=f070454a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f070454a",
  null
  
)

export default component.exports